import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 0,
  class: "upload-avatar-button btn btn-icon btn-circle btn-active-color-primary bg-white shadow",
  "data-kt-image-input-action": "edit",
  title: "Edit Profile",
  "data-bs-toggle": "modal",
  "data-bs-target": "#t2o_profile_form_modal"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-camera" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_avatar, {
      size: _ctx.size,
      src: _ctx.imageSrc,
      style: _normalizeStyle({
      border: `1px solid ${_ctx.borderColor}`,
      color: `${_ctx.textColor} !important`,
      backgroundColor: `${_ctx.backgroundColor} !important`,
    }),
      fit: "fill",
      class: "d-flex justify-content-center"
    }, {
      default: _withCtx(() => [
        (_ctx.defaultError === 'icon')
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: require('@/assets/new-design/images/default-user.png')
            }, null, 8, _hoisted_1))
          : _createCommentVNode("", true),
        (_ctx.defaultError === 'acronym')
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              style: _normalizeStyle({
        'font-size': _ctx.fontSize,
      })
            }, _toDisplayString(_ctx.acronym), 5))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["size", "src", "style"]),
    (_ctx.withUploadButton)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true)
  ], 64))
}